import React from 'react'
import { Button } from '@mui/material'
import { useSnackbar } from 'notistack'
import {
  useGetDealerLuckyDrawById,
  usePatchDealerLuckyDrawApprove,
} from '../../../../../api/promotions/dealer/dealer-lucky-draw'

const ApproveButton = ({ id }) => {
  const { mutateAsync, isLoading } = usePatchDealerLuckyDrawApprove(id)

  const { refetch } = useGetDealerLuckyDrawById(id)

  const { enqueueSnackbar } = useSnackbar()

  const handleApprove = async () => {
    try {
      const res = await mutateAsync()

      // Display success on popup
      enqueueSnackbar(`Approved successfully`, {
        variant: 'success',
      })

      // Refetch data
      refetch()
    } catch (error) {
      // Display error on popup
      enqueueSnackbar(error?.response?.data?.message ?? 'Failed to approve', {
        variant: 'error',
        autoHideDuration: 7000,
      })
    }
  }

  return (
    <Button
      variant='contained'
      size='large'
      color='success'
      disabled={isLoading}
      onClick={handleApprove}
    >
      Approve
    </Button>
  )
}

export default ApproveButton
